import React from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import { isEmpty, isNotEmpty, isNothing, isSomething, url } from "../../utils";
import { trackingShape, withTracking } from "../../context";

type OwnProps = {
  placeholder?: string;
  onSearch: $TSFixMeFunction;
  disabled?: boolean;
  minChars?: number;
  resettable?: boolean;
  timeout?: number;
  filterWildcard?: boolean;
  hideSubmit?: boolean;
  scanSearchSource?: string;
  tracking?: trackingShape;
  searchCount?: number;
  onInputChange?: $TSFixMeFunction;
  onClick?: $TSFixMeFunction;
  inputName?: string;
  id?: string;
  defaultValue?: string;
};

const defaultProps: Partial<OwnProps> = {
  timeout: 800,
  filterWildcard: true,
  resettable: true,
  minChars: 1,
  disabled: false,
  placeholder: "",
  defaultValue: "",
};

type Props = OwnProps & typeof defaultProps;

export function SearchBar(props: Props) {
  const {
    placeholder,
    disabled,
    resettable,
    timeout,
    onSearch,
    onClick,
    onInputChange,
    searchCount,
    filterWildcard,
    minChars,
    hideSubmit,
    scanSearchSource,
    tracking,
    inputName,
    id,
    defaultValue,
  } = props;

  const navigate = useNavigate();
  const inputRef = React.useRef();
  const timeoutRef = React.useRef(null);

  const [term, setTerm] = React.useState("");

  React.useEffect(() => {
    // @ts-expect-error TS(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
    setTerm(defaultValue);
  }, [defaultValue]);

  const focus = () => {
    setTimeout(() => {
      // eslint-disable-next-line no-unused-expressions
      (inputRef.current as $TSFixMe)?.focus();
    }, 50);
  };

  const search = (newValue: $TSFixMe) => {
    if (filterWildcard && newValue.match(/^[*]+$/g)) {
      onSearch("");
    } else {
      onSearch(newValue);
    }
    focus();
  };

  function handleInputChange(newValue: $TSFixMe) {
    setTerm(newValue);
    // @ts-expect-error TS(2769) FIXME: No overload matches this call.
    clearTimeout(timeoutRef.current);
    if (isEmpty(newValue)) {
      search("");
      return;
    }
    if (minChars && newValue.length < minChars) {
      return;
    }
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    if (timeout > 0) {
      // @ts-expect-error TS(2322) FIXME: Type 'Timeout' is not assignable to type 'null'.
      timeoutRef.current = setTimeout(() => {
        search(newValue);
      }, timeout);
    } else {
      search(newValue);
    }
  }

  function resetInput(e: $TSFixMe) {
    e.stopPropagation();
    setTerm("");
    handleInputChange("");
  }

  const handleSubmit = (e: $TSFixMe) => {
    e.preventDefault();
    search(term);
  };

  const handleOnClick = (e: $TSFixMe) => {
    e.preventDefault();
    if (isSomething(scanSearchSource)) {
      navigate(url(`${scanSearchSource}/search_scan`));
      return;
    }
    handleSubmit(e);
  };

  const resetButton =
    resettable && isNotEmpty(term) ? (
      <button
        data-testid="reset-search"
        type="button"
        className="btn reset-button"
        onClick={resetInput}
        disabled={disabled}
      >
        <i className="icon icon-eh-close" />
      </button>
    ) : null;

  let buttonClass = "lcm-iot-icon-scan";
  if (isNothing(scanSearchSource)) {
    buttonClass = "icon-eh-search";
  }

  const onSearchInputDone = () => {
    if (term?.length && tracking)
      tracking.trackEvent("Search-started", {
        searchResultCount: searchCount,
        searchTermLength: term.length,
        searchTerm: term,
      });
  };

  return (
    <div className="search-bar">
      <form className="searchForm" onSubmit={handleSubmit} noValidate>
        {!hideSubmit && (
          <button
            data-testid="search-submit"
            type="button"
            id="searchSubmit"
            className={`btn ${buttonClass}`}
            onClick={handleOnClick}
            disabled={disabled}
          />
        )}
        <div className="search-bar-items">
          <input
            name={inputName || "search"}
            id={id || "searchInputField"}
            data-testid="search-input"
            onChange={(e) => {
              if (disabled) return;

              handleInputChange(e?.target.value);
              onInputChange?.();
            }}
            type="text"
            placeholder={placeholder}
            disabled={disabled}
            value={term}
            // @ts-expect-error TS(2322) FIXME: Type 'MutableRefObject<undefined>' is not assignab... Remove this comment to see the full error message
            ref={inputRef}
            onBlur={onSearchInputDone}
            onClick={onClick}
          />
          {resetButton}
        </div>
      </form>
    </div>
  );
}

SearchBar.defaultProps = defaultProps;

// @ts-expect-error TS(2345) FIXME: Argument of type 'typeof SearchBar' is not assigna... Remove this comment to see the full error message
export default withTracking(SearchBar);
